import React, { useEffect, useState } from "react";
import { Wrapper, CaptchaCotainer } from "./styled";
import Captcha from "../Captcha";
import PaymentButton from "./components/PaymentButton";
import PrintButton from "./components/PrintButton";
import Alert from "../../../../commons/Alert";
import { useSelector } from "react-redux";
import { payment } from "../../../../../store/Concept/selectors";

const Buttons = ({ detail }) => {
  const paymentRequest = useSelector(payment);
  const [paymentError, setPaymentError] = useState(false);

  useEffect(() => {
    if (paymentRequest) {
      if (paymentRequest.estado == "GENERADA"){
        setPaymentError(false);
      } else {
        setPaymentError(true);
      }
    }
  }, [paymentRequest]);

  return (
    <Wrapper>
      <Alert paymentError={paymentError} />
      <CaptchaCotainer>
        <Captcha detail={detail} />
      </CaptchaCotainer>
      <PrintButton />
      <PaymentButton detail={detail} />
    </Wrapper>
  );
};

export default Buttons;
